import type {
  ScheduleMode,
  BackupSchedule,
  Condition,
  BackupPolicyType,
  ResourceType,
} from '@repo/api-gw-sdk';

import type { ResourcesScopeType } from '@/components/resourcesSelection/resourceSelectionDynamicViewer';
import type { Step } from '@/components/wizard/Step';

import { BackupPolicyConditionEditor } from './BackupPolicyConditionEditor';
import { BackupPolicyNameSelection } from './BackupPolicyNameSelection';
import { BackupPolicyResourcesList } from './BackupPolicyResourcesList';
import { BackupPolicySettings } from './BackupPolicySettings';

export interface BackupPolicyEditState {
  id: string;
  name: string;
  condition?: Condition;
  focusOnName: boolean;
  schedules?: BackupSchedule[];
  include: string[];
  exclude: string[];
  resourcesScopeType: ResourcesScopeType;
  mode: ScheduleMode;
  policyType: BackupPolicyType;
  resourceTypes?: ResourceType[];
}

export const EditBackupPolicyFlow: Step<BackupPolicyEditState> = {
  id: 'name_selection',
  Component: BackupPolicyNameSelection,
  nonReturnable: true,
  next: [
    {
      id: 'resource_selection',
      Component: BackupPolicyConditionEditor,
      next: [
        {
          id: 'resource_list',
          Component: BackupPolicyResourcesList,
          next: [
            {
              id: 'backup_schedules',
              Component: BackupPolicySettings,
            },
          ],
        },
      ],
    },
  ],
};
